import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { PageProps } from '@/types'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'

export const pageUrl = '/[locale]/fundraising-events/[slug]/manage/live-widgets/top-donation'
export const getPageUrl = toPathFactory(pageUrl, getPublicUrl)
export type TopDonationPageProps = PageProps<typeof pageUrl>
